jQuery(document).ready(function($){

  $('.reviews-slider').slick({
    dots: false,
    arrows: false,
    appendArrows: '#append-review-arrows',
    appendDots: '#append-review-dots',
    prevArrow: '<div class="flex-container align-middle align-center circle reviews-nav"><i class="fal fa-angle-left"></i></div>',
    nextArrow: '<div class="flex-container align-middle align-center circle reviews-nav"><i class="fal fa-angle-right"></i></div>',
    responsive: [{
      breakpoint: 767,
      settings: {
        arrows: true,
        dots: true,
      }
    }]
  });

  var reviewsSliderNav = {

    construct: function() {
      this.navItems = $('.reviews-nav-container').find('span');
      this.prev = $('#reviews-previous');
      this.next = $('#reviews-next');
      this.slider = $('.reviews-slider');
      this.next.on('click', this.progress.bind(this));
      this.prev.on('click', this.regress.bind(this));
      this.navItems.on('click', this.goToSlide.bind(this))
      this.slider.on('beforeChange', this.respondToSliderChange.bind(this))
    },


    progress: function() {
      this.slider.slick('slickNext');
      this.setActiveNavItem(this.slider.slick('slickCurrentSlide'));
    },

    regress: function() {
      this.slider.slick('slickPrev');
      this.setActiveNavItem(this.slider.slick('slickCurrentSlide'));
    },

    goToSlide: function(event) {
      let i = this.navItems.index(event.target)
      this.setActiveNavItem(i);
      this.slider.slick('slickGoTo', i);
    },

    setActiveNavItem: function(i) {
      this.navItems.each(function(index, item) {
        index === i ? $(item).addClass('active') : $(item).removeClass('active');
      })
    },

    respondToSliderChange: function(e, s, c, n) {
      this.setActiveNavItem(n);
    }

  }

  reviewsSliderNav.construct();



});
